export const SAVE_ALL_PENDING_RELEASES = 'SAVE_ALL_PENDING_RELEASES'